// extracted by mini-css-extract-plugin
export var aircallIframe = "_jv-3";
export var fabContainer = "_jv-5";
export var fabRinging = "_jv-6";
export var loadingOverlay = "_jv-4";
export var pulse = "_jv-7";
export var widgetContent = "_jv-2";
export var widgetPanel = "_jv-0";
export var widgetPanelExpanded = "_jv-1";